import Select from "components/shared/select";
import React from "react";
import { getOrganizationNames } from "sources/admin";

const OrganizationFilter = (props) => {
    const selectProps = {
        inputProps: { name: "organizationId" },
        value: props.values.organizationId,
        placeholder: "Организация",
        url: getOrganizationNames,
        propName: "name",
        onChange: props.setFilter,
        className: "report__filters--control",
    };
    return (
        <div className="mb-md-0 report__filters--mr">
            <Select {...selectProps} />
        </div>
    );
};

export default OrganizationFilter;
